export function parseUnits(hashrate, appendix = 'H/s') {
    let unit = 'K';
    let formated = hashrate;
    const base = 1000;
    if (hashrate < base) return `${Math.round(hashrate * 100) / 100} ${appendix}`;
    const units = ['K', 'M', 'G', 'T', 'P', 'E', '?'];

    for (let i = 1; i < 7; i++) {
        const x = base ** i;
        if (hashrate < x) break;

        formated = Math.round(hashrate / x * 100) / 100;
        unit = units[i - 1];
    }

    return `${formated} ${unit}${appendix}`;
};

export function toBaseUnit(value, unit = 'T') {
    if (unit.toUpperCase() == 'K') return value * 1000;
    else if (unit.toUpperCase() == 'M') return value * 1000 * 1000;
    else if (unit.toUpperCase() == 'G') return value * 1000 * 1000 * 1000;
    else if (unit.toUpperCase() == 'T') return value * 1000 * 1000 * 1000 * 1000;
    else if (unit.toUpperCase() == 'P') return value * 1000 * 1000 * 1000 * 1000 * 1000;
    else return value;
};

export function submitsToHashrate(submits, timeSec = 3600) {
    return Math.round(submits * 4294967296 / timeSec);
};

export function formatHash(dataArray) {
    let hex = "";
    let i = 0;
    for (const d of dataArray) {
        if (i && i % 2 == 0) hex += " ";
        hex += parseInt(d).toString(16).padStart(2, '0').slice(0, 2);
        i += 1;
    }
    return hex;
};

export function formatNumberWithSpaces(value) {
    return parseInt(value).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
}

export function formatCoinbasePrice(coin, coinbasevalue, usdPrice) {
    let mul = 100000000;
    if (coin == 'xec') mul = 100;

    const val = (coinbasevalue / mul) * usdPrice;
    return Math.round(val * 100) / 100;
}

export function formatCurrency(value) {
    if (typeof value !== "number") {
        return value;
    }
    const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
    });
    return formatter.format(value);
}

export function getExplorerLink(coin, height) {
    if (coin == 'rvn') {
        return `https://rvn.tokenview.io/en/block/${height}`;
    } else if (coin == 'dgb') {
        return `https://chainz.cryptoid.info/dgb/block.dws?${height}.htm`;
    } else if (coin == 'bch') {
        return `https://explorer.bitcoinunlimited.info/block-height/${height}`;
    } else if (coin == 'btc') {
        return 'https://blockchair.com/bitcoin/block/' + height;
    } else if (coin == 'xec') {
        return `https://explorer.e.cash/block-height/${height}`;
    }
}
